import { writable } from 'svelte/store';

// 초기 상태를 localStorage에서 로드하거나 기본값 설정
const initialUserState = JSON.parse(localStorage.getItem('user')) || {};
export const user = writable(initialUserState);

const initialState = localStorage.getItem('isAuthenticated') === 'true';

export const isAuthenticated = writable(initialState);

// 구독을 통해 store의 변경 사항을 감지하고 localStorage에 저장
isAuthenticated.subscribe(value => {
    localStorage.setItem('isAuthenticated', value);
    if (!value) {
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
    }
});

// 서버 config에서 내려오는 숨김 메뉴 키 목록 (GNB 상위 섹션 키 또는 하위 메뉴 라우트 경로)
export const hiddenMenus = writable(new Set());

// V-WORLD 지도 타일/지오코딩 인증키 (서버 config에서 내려옴)
export const vworldKey = writable('');
export const niceCMSTest = writable(false);

export async function loadConfig() {
    try {
        const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/config`);
        if (response.ok) {
            const config = await response.json();
            hiddenMenus.set(new Set(config.hiddenMenus || []));
            vworldKey.set(config.vworldKey || '');
            niceCMSTest.set(config.niceCMSTest === true);
        }
    } catch (e) {
        console.error('Config load failed:', e);
    }
}
